import { ChangeEventHandler, forwardRef, memo, useCallback } from "react";
import { Input, InputProps } from "../Input";

export type TextFieldProps = Omit<InputProps, "component" | "onChange" | "value"> & {
  onChange?: (value: string | null) => void,
  value?: string | null
}

export const TextField = memo(forwardRef<HTMLInputElement, TextFieldProps>(({ onChange, value, ...props }, ref) => {
  const wrappedOnChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => onChange?.(e?.target?.value || null),
    [ onChange ],
  );
  return (
    <Input
      value={value || ""}
      ref={ref}
      component={"input"}
      type="text"
      {...props}
      onChange={wrappedOnChange}
    />
  );
}));

export default TextField;
